import { events } from '@estee/elc-service-bus';
import { AccountPageLandedUseCase } from '~use-cases/AccountPageLandedUseCase';
import { AccountLoyaltyPointsInfoUseCase } from '~use-cases/AccountLoyaltyPointsInfoUseCase';
import { AccountNonLoyaltyEnrollmentLinkUseCase } from '~use-cases/AccountNonLoyaltyEnrollmentLinkUseCase';
import { AccountNonLoyaltyEnrollmentSignupUseCase } from '~use-cases/AccountNonLoyaltyEnrollmentSignupUseCase';
import { CartLandingPageViewedUseCase } from '~use-cases/CartLandingPageViewedUseCase';
import { CartLoggedInUseCase } from '~use-cases/CartLoggedInUseCase';
import { ProductImpressionsUseCase } from '~use-cases/ProductImpressionsUseCase';
import { ProductViewedUseCase } from '~use-cases/ProductViewedUseCase';
import { CreateAccountAttemptUseCase } from '~use-cases/CreateAccountAttemptUseCase';
import { CreateAccountFailUseCase } from '~use-cases/CreateAccountFailUseCase';
import { ItemAddedUseCase } from '~use-cases/ItemAddedUseCase';
import { ManualOfferCodeAppliedUseCase } from '~use-cases/ManualOfferCodeAppliedUseCase';
import { MppFilteredUseCase } from '~use-cases/MppFilteredUseCase';
import { OrderConfirmationPageLandedUseCase } from '~use-cases/OrderConfirmationPageLandedUseCase';
import { PaymentMethodCompletedUseCase } from '~use-cases/PaymentMethodCompletedUseCase';
import { PaymentPageViewedUseCase } from '~use-cases/PaymentPageViewedUseCase';
import { ProductClickedUseCase } from '~use-cases/ProductClickedUseCase';
import { QuickViewUseCase } from '~use-cases/QuickViewUseCase';
import { RemoveItemUseCase } from '~use-cases/RemoveItemUseCase';
import { SampleAddedUseCase } from '~use-cases/SampleAddedUseCase';
import { SearchAddressSubmittedUseCase } from '~use-cases/SearchAddressSubmittedUseCase';
import { ShippingAddressFilledUseCase } from '~use-cases/ShippingAddressFilledUseCase';
import { ShippingOptionSelectedUseCase } from '~use-cases/ShippingOptionSelectedUseCase';
import { ShippingPageViewedUseCase } from '~use-cases/ShippingPageViewedUseCase';
import { StoreLocationSelectedUseCase } from '~use-cases/StoreLocationSelectedUseCase';
import { StoreLocatorClickedUseCase } from '~use-cases/StoreLocatorClickedUseCase';
import { StoreMarkerClickedUseCase } from '~use-cases/StoreMarkerClickedUseCase';
import { StoreTownSelectedUseCase } from '~use-cases/StoreTownSelectedUseCase';
import { SubscribedForEmailsUseCase } from '~use-cases/SubscribedForEmailsUseCase';
import { TransactionFailedUseCase } from '~use-cases/TransactionFailedUseCase';
import { TransactionSuccededUseCase } from '~use-cases/TransactionSuccededUseCase';
import { AnalyticsLoadedUseCase } from '~use-cases/AnalyticsLoadedUseCase';
import { SkuEngravingUseCase } from '~use-cases/SkuEngravingUseCase';
import { GridFilteredUseCase, IAnalyticsFilters } from '~use-cases/GridFilteredUseCase';
import { GridSortedUseCase } from '~use-cases/GridSortedUseCase';
import { ShadeGroupSelectedUseCase } from '~use-cases/ShadeGroupSelectedUseCase';
import { ShadeChangeViewedUseCase } from '../internal/use-cases/ShadeChangeViewedUseCase';
import { LiveChatInterfaceClickedUseCase } from '~use-cases/LiveChatInterfaceClickedUseCase';
import { ProductComparisonViewedUseCase } from '~use-cases/ProductComparisonViewedUseCase';
import { SocialShareIconTriggeredUseCase } from '~use-cases/SocialShareIconTriggeredUseCase';
import { StoreBookVirtualAppointmentClickedUseCase } from '~use-cases/StoreBookVirtualAppointmentClickedUseCase';
import { SkuPickerInteractionUseCase } from '~use-cases/SkuPickerInteractionUseCase';
import { AccountSidebarOverlayOpenedUseCase } from '~use-cases/AccountSidebarOverlayOpenedUseCase';
import { AccountSidebarMenuOptionClickedUseCase } from '~use-cases/AccountSidebarMenuOptionClickedUseCase';
import { AccountSidebarShowcaseClickedUseCase } from '~use-cases/AccountSidebarShowcaseClickedUseCase';
import { AccountEventAction } from '~constants/Account';
import { AppointmentVirtualSelectedUseCase } from '~use-cases/AppointmentVirtualSelectedUseCase';
import { AppointmentServiceSelectedUseCase } from '~use-cases/AppointmentServiceSelectedUseCase';
import { AppointmentDateTimeSelectedUseCase } from '~use-cases/AppointmentDateTimeSelectedUseCase';
import { AppointmentEditClickedUseCase } from '~use-cases/AppointmentEditClickedUseCase';
import { AppointmentStartedOverUseCase } from '~use-cases/AppointmentStartedOverUseCase';
import { AppointmentArtistSelectedUseCase } from '~use-cases/AppointmentArtistSelectedUseCase';
import { AppointmentStepLoadedUseCase } from '~use-cases/AppointmentStepLoadedUseCase';
import { AppointmentProcessCompletedUseCase } from '~use-cases/AppointmentProcessCompletedUseCase';
import { AppointmentAddedToCalendarUseCase } from '~use-cases/AppointmentAddedToCalendarUseCase';
import { AppointmentAccountButtonClickedUseCase } from '~use-cases/AppointmentAccountButtonClickedUseCase';
import { AppointmentCallStoreClickedUseCase } from '~use-cases/AppointmentCallStoreClickedUseCase';
import {
    SearchProductsQueriedUseCase,
    ISearchProductsQueried
} from '~use-cases/SearchProductsQueriedUseCase';
import {
    SearchTermSelectedUseCase,
    ISearchTermSelected
} from '~use-cases/SearchTermSelectedUseCase';
import { VTOActionUseCase } from '~use-cases/VTOActionUseCase';

import * as routes from '~constants/Routes';
import { ProductNotifyMeTriggeredUseCase } from '~use-cases/ProductNotifyMeTriggeredUseCase';
import { ProductNotifyMeRequestCompletedUseCase } from '~use-cases/ProductNotifyMeRequestCompletedUseCase';

import {
    IAccountSidebarBaseData,
    IAccountSidebarShowcaseData,
    IGenericAnalyticsData,
    IProductViewed,
    IProductImpressions,
    IReviewsData,
    ISmartGiftData,
    ISkinCareProducts,
    IVtoLoaded,
    IVtoType,
    IVtoProductsUsedItemClicked,
    IVtoLookSelected,
    IVtoBrowGoalSelected,
    IVtoShapeChanged,
    IVtoBrowShadeTryOn,
    IVtoLengthChanged,
    IVtoThicknessChanged,
    IVtoOpacityChanged,
    IStoreDeliveryMethodsData
} from '~interfaces/IAnalytics';
import { RatingsReviewsUseCase } from '~use-cases/RatingsReviewsUseCase';

import { ReviewsEventAction } from '~constants/RatingsReviews';
import { SmartGiftUseCase } from '~use-cases/SmartGiftUseCase';
import { SmartGiftEventAction } from '~constants/SmartGift';
import { VTO_EVENTS } from '~constants/Vto';
import { ActionType } from '~constants/ActionType';
import { IOfferViewedProps, OfferViewed } from '~use-cases/OfferViewed';
import { IOfferClickedProps, OfferClicked } from '~use-cases/OfferClicked';
import { CartTabTabClicked } from '~use-cases/OffersTabClicked';
import { CartOverlayClosed } from '~use-cases/CartOverlayClosed';
import { CartOverlayOpened } from '~use-cases/CartOverlayOpened';
import { AppointmentLocationSelectedUseCase } from '~use-cases/AppointmentLocationSelectedUseCase';
import { PageViewUseCase } from '~use-cases/PageViewUseCase';
import { LoyaltyEventAction } from '~constants/Loyalty';
import { LoyaltyPointsUseCase } from '~use-cases/LoyaltyPointsUseCase';
import { LoyaltyBenefitsUseCase } from '~use-cases/LoyaltyBenefitsUseCase';
import { LoyaltyRewardsUseCase } from '~use-cases/LoyaltyRewardsUseCase';
import {
    SearchFiltersSelectedUsecase,
    ISearchFiltersSelected
} from '~use-cases/SearchFiltersSelectedUseCase';
import { AppointmentReviewWidgetClickUseCase } from '~use-cases/AppointmentReviewWidgetClickUseCase';
import { AppointmentReviewPaginationUseCase } from '~use-cases/AppointmentReviewPaginationUseCase';
import { AppointmentReviewWidgetFiltersUseCase } from '~use-cases/AppointmentReviewWidgetFiltersUseCase';
import { StoreDeliveryMethodsUseCase } from '~use-cases/StoreDeliveryMethodsUseCase';

export interface IOrderDetail {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    [key: string]: any;
}

export interface IOrderQueryData {
    orderId: string;
    guestToken: string;
    paymentType: string;
}

type IReviewsParam = Omit<IReviewsData, 'eventAction'>;
type ISmartGiftParam = Omit<ISmartGiftData, 'eventAction'>;

const SHIPPING_SCREEN_SHIPPING_ADDRESS_SELECTION_CONTEXT =
    'checkout_shipping_screen_shipping_address_selection';
const QUICK_VIEW = 'QV';

export class ServiceBusController {
    private orderQueryData: IOrderQueryData;

    public analyticsLoaded = () => {
        const analyticsLoadedUseCase = new AnalyticsLoadedUseCase();
        analyticsLoadedUseCase.execute();
    };

    public pageViewed = () => {
        new PageViewUseCase().execute();
    };

    public productViewedUseCase = (payload: IProductViewed) => {
        new ProductViewedUseCase(payload).execute();
    };

    public shadeChangeViewedUseCase = (payload: IProductViewed) => {
        new ShadeChangeViewedUseCase(payload).execute();
    };

    public productImpressionUseCase = (payload: IProductImpressions) => {
        new ProductImpressionsUseCase(payload).execute();
    };

    public storeDetailsClicked = (payload: { storeId: string; storeName: string }) => {
        const storeLocatorClickedUseCase = new StoreLocatorClickedUseCase(
            payload.storeId,
            payload.storeName,
            events.STORE_DETAILS_CLICKED
        );
        storeLocatorClickedUseCase.execute();
    };

    public getDirectionsClicked = (payload: { storeId: string; storeName: string }) => {
        const getDirectionsClickedUseCase = new StoreLocatorClickedUseCase(
            payload.storeId,
            payload.storeName,
            events.GET_DIRECTIONS_CLICKED
        );
        getDirectionsClickedUseCase.execute();
    };

    public storeInfoClicked = (payload: { storeId: string; storeName: string }) => {
        const storeInfoClickedUseCase = new StoreLocatorClickedUseCase(
            payload.storeId,
            payload.storeName,
            events.STORE_INFO_CLICKED
        );
        storeInfoClickedUseCase.execute();
    };

    public storeMarkerClicked = (payload: { storeId: string }) => {
        const storeMarkerClickedUseCase = new StoreMarkerClickedUseCase(payload.storeId);
        storeMarkerClickedUseCase.execute();
    };

    public storePhoneClicked = (payload: { storeId: string; storeName: string }) => {
        const storePhoneClickedUseCase = new StoreLocatorClickedUseCase(
            payload.storeId,
            payload.storeName,
            events.STORE_PHONE_CLICKED
        );
        storePhoneClickedUseCase.execute();
    };

    public bookAppointmentClicked = (payload: { storeId: string; storeName: string }) => {
        const bookAppointmentClickedUseCase = new StoreLocatorClickedUseCase(
            payload.storeId,
            payload.storeName,
            events.BOOK_APPOINTMENT_CLICKED
        );
        bookAppointmentClickedUseCase.execute();
    };

    public bookVirtualAppointmentClicked = (payload: { isVirtual: boolean }) => {
        const bookVirtualAppointmentClickedUseCase = new StoreBookVirtualAppointmentClickedUseCase(
            payload.isVirtual,
            events.BOOK_VIRTUAL_APPOINTMENT_CLICKED
        );
        bookVirtualAppointmentClickedUseCase.execute();
    };

    public storeLocationSelected = (payload: { storeId: string }) => {
        const storeLocationSelectedUseCase = new StoreLocationSelectedUseCase(payload.storeId);
        storeLocationSelectedUseCase.execute();
    };

    public storeTownSelected = (payload: { town: string }) => {
        const storeTownSelectedUseCase = new StoreTownSelectedUseCase(payload.town);
        storeTownSelectedUseCase.execute();
    };

    public searchAddressSubmitted = (payload: { address: string }) => {
        const searchAddressSubmittedUseCase = new SearchAddressSubmittedUseCase(payload.address);
        searchAddressSubmittedUseCase.execute();
    };

    public trackOrderDetails = (orderQueryData: IOrderQueryData) => {
        this.orderQueryData = orderQueryData;
    };

    public createAccountAttempt = () => {
        const createAccountAttemptUseCase = new CreateAccountAttemptUseCase();
        createAccountAttemptUseCase.execute();
    };

    public removeItem = async (payload: { skuId: string }) => {
        const removeItemUseCase = new RemoveItemUseCase(payload.skuId);
        removeItemUseCase.execute();
    };

    public createAccountFail = (error: string) => {
        const createAccountFailUseCase = new CreateAccountFailUseCase(error);
        createAccountFailUseCase.execute();
    };

    public applyOfferCode = async () => {
        const manualOfferCodeAppliedUseCase = new ManualOfferCodeAppliedUseCase();
        manualOfferCodeAppliedUseCase.execute();
    };

    public offerCodeFailed = async () => {
        const manualOfferCodeAppliedUseCase = new ManualOfferCodeAppliedUseCase();
        manualOfferCodeAppliedUseCase.execute();
    };

    public productClicked = async (payload: {
        skuId: string;
        positionIndex: number;
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        product?: any;
    }) => {
        const { skuId, positionIndex, product } = payload;
        const pageType = '';
        const productClickedUseCase = new ProductClickedUseCase(
            skuId,
            pageType,
            positionIndex,
            product
        );
        productClickedUseCase.execute();
    };

    public productNotifyMeTriggered = async (payload: { skuId: string }) => {
        const productNotifyMeTriggeredUseCase = new ProductNotifyMeTriggeredUseCase(payload.skuId);
        productNotifyMeTriggeredUseCase.execute();
    };

    public productNotifyMeRequestSuccess = async (payload: { skuId: string }) => {
        const eventAction = 'notify me - success';

        const productNotifyMeRequestCompletedUseCase = new ProductNotifyMeRequestCompletedUseCase(
            payload.skuId,
            events.PRODUCT_NOTIFY_ME_REQUEST_SUCCESS,
            eventAction
        );
        productNotifyMeRequestCompletedUseCase.execute();
    };

    public productNotifyMeRequestFailure = async (payload: { skuId: string }) => {
        const eventAction = 'notify me - fail';

        const productNotifyMeRequestCompletedUseCase = new ProductNotifyMeRequestCompletedUseCase(
            payload.skuId,
            events.PRODUCT_NOTIFY_ME_REQUEST_FAILURE,
            eventAction
        );
        productNotifyMeRequestCompletedUseCase.execute();
    };

    public itemAdded = async (payload: { skuId: string }) => {
        const itemAddedUseCase = new ItemAddedUseCase(payload.skuId);
        itemAddedUseCase.execute();
    };

    public sampleAdded = async () => {
        const sampleAddedUseCase = new SampleAddedUseCase();
        sampleAddedUseCase.execute();
    };

    public shippingOptionSelected = () => {
        const shippingOptionSelectedUseCase = new ShippingOptionSelectedUseCase();
        shippingOptionSelectedUseCase.execute();
    };

    public cartLoggedIn = () => {
        const cartLoggedInUseCase = new CartLoggedInUseCase();
        cartLoggedInUseCase.execute();
    };

    public shippingAddressFilled = ({ context }: { context: string }) => {
        if (context === SHIPPING_SCREEN_SHIPPING_ADDRESS_SELECTION_CONTEXT) {
            const shippingAddressFilledUseCase = new ShippingAddressFilledUseCase();
            shippingAddressFilledUseCase.execute();
        }
    };

    public paymentMethodCompleted = () => {
        const paymentMethodCompletedUseCase = new PaymentMethodCompletedUseCase();
        paymentMethodCompletedUseCase.execute();
    };

    public orderConfirmationPageLanded = async (payload: IOrderDetail) => {
        const orderConfirmationPageLandedUseCase = new OrderConfirmationPageLandedUseCase(payload);
        await orderConfirmationPageLandedUseCase.execute();
    };

    public subscribedForEvents = () => {
        const subscribedForEventsUseCase = new SubscribedForEmailsUseCase();
        subscribedForEventsUseCase.execute();
    };

    public cartPageView = async () => {
        const cartLandingPageViewedUseCase = new CartLandingPageViewedUseCase();
        await cartLandingPageViewedUseCase.execute();
    };

    public transactionFailed = () => {
        const transactionFailedUseCase = new TransactionFailedUseCase(this.orderQueryData);
        transactionFailedUseCase.execute();
    };

    public transactionSucceded = () => {
        const transactionSuccededUseCase = new TransactionSuccededUseCase(this.orderQueryData);
        transactionSuccededUseCase.execute();
    };

    public filterMpp = async (payload: { method: string }) => {
        const mppFilteredUseCase = new MppFilteredUseCase(payload.method);
        mppFilteredUseCase.execute();
    };

    public filterGrid = async (payload: { appliedFilters: IAnalyticsFilters[] }) => {
        const gridFilteredUseCase = new GridFilteredUseCase(payload.appliedFilters);
        gridFilteredUseCase.execute();
    };

    public sortGrid = async (payload: { appliedSort: string }) => {
        const sortFilteredUseCase = new GridSortedUseCase(payload.appliedSort);
        await sortFilteredUseCase.execute();
    };

    public quickViewSelected = (payload: {
        skuId: string;
        positionIndex: number;
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        product?: any;
    }) => {
        const pageType = QUICK_VIEW;
        const { skuId, positionIndex, product } = payload;
        const quickViewSelectedUseCase = new QuickViewUseCase(skuId, product);
        const productClickedUseCase = new ProductClickedUseCase(
            skuId,
            pageType,
            positionIndex,
            product
        );
        quickViewSelectedUseCase.execute();
        productClickedUseCase.execute();
    };

    public cartOverlayClosed = async (payload: { nonInteraction: boolean }) =>
        new CartOverlayClosed(payload).execute();

    public cartOverlayOpened = async (payload: { nonInteraction: boolean }) =>
        new CartOverlayOpened(payload).execute();

    public cartTabClicked = async ({ tabId }: { tabId: string }) => {
        const payload = { tabId, event: events.CART_OVERLAY_TAB_CLICKED };
        new CartTabTabClicked(payload).execute();
    };

    public cartOverlayOfferClicked = async (payload: IOfferClickedProps) => {
        new OfferClicked(payload).execute();
    };

    public cartOverlayOfferViewed = async (payload: IOfferViewedProps) => {
        new OfferViewed(payload).execute();
    };

    public shadeGroupSelected = (payload: {
        shadeGroupKey: string;
        eventName: string;
        eventAction: string;
    }) => {
        const { shadeGroupKey, eventName, eventAction } = payload;
        const shadeGroupSelectedUseCase = new ShadeGroupSelectedUseCase(
            shadeGroupKey,
            eventName,
            eventAction
        );
        shadeGroupSelectedUseCase.execute();
    };

    public productComparisonViewed = (payload: { productIds: string[] }) => {
        const { productIds } = payload;
        const productComparisonViewedUseCase = new ProductComparisonViewedUseCase(productIds);
        productComparisonViewedUseCase.execute();
    };

    public searchProductsQueried = (payload: ISearchProductsQueried) => {
        const searchProductsQueriedUseCase = new SearchProductsQueriedUseCase(payload);
        searchProductsQueriedUseCase.execute();
    };

    public searchTermSelected = (payload: ISearchTermSelected) => {
        const searchTermSelectedUseCase = new SearchTermSelectedUseCase(payload);
        searchTermSelectedUseCase.execute();
    };

    public searchFiltersSelected = (payload: ISearchFiltersSelected) => {
        const searchFiltersSelectedUsecase = new SearchFiltersSelectedUsecase(payload);
        searchFiltersSelectedUsecase.execute();
    };

    public navigatedToPageView = async ({ currentRoute }: { currentRoute: string }) => {
        switch (currentRoute) {
            case routes.ACCOUNT_LANDING:
            case routes.LOGIN:
                const accountPageLandedUseCase = new AccountPageLandedUseCase();
                accountPageLandedUseCase.execute();
                break;

            case routes.SHIPPING:
                const shippingPageViewedUseCase = new ShippingPageViewedUseCase();
                shippingPageViewedUseCase.execute();
                break;

            case routes.PAYMENT:
                const paymentPageViewedUseCase = new PaymentPageViewedUseCase();
                paymentPageViewedUseCase.execute();
                break;

            default:
                return;
        }
    };

    public vtoCameraClosed = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.CAMERA_CLOSED,
            vtoType: payload.vtoType
        };
        const vtoCameraClosedUseCase = new VTOActionUseCase(vtoAction);

        vtoCameraClosedUseCase.execute();
    };

    public vtoCameraFailed = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.CAMERA_FAILED,
            vtoType: payload.vtoType
        };
        const vtoCameraFailedUseCase = new VTOActionUseCase(vtoAction);

        vtoCameraFailedUseCase.execute();
    };

    public vtoCameraOpened = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.CAMERA_OPENED,
            vtoType: payload.vtoType
        };
        const vtoCameraOpenedUseCase = new VTOActionUseCase(vtoAction);

        vtoCameraOpenedUseCase.execute();
    };

    public vtoCompare = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.COMPARE,
            vtoType: payload.vtoType
        };
        const vtoCompareUseCase = new VTOActionUseCase(vtoAction);

        vtoCompareUseCase.execute();
    };

    public vtoCompareDisabled = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.COMPARE_DISABLED,
            vtoType: payload.vtoType
        };
        const vtoCompareDisabledUseCase = new VTOActionUseCase(vtoAction);

        vtoCompareDisabledUseCase.execute();
    };

    public vtoClosed = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.CLOSED,
            vtoType: payload.vtoType
        };
        const vtoClosedUseCase = new VTOActionUseCase(vtoAction);

        vtoClosedUseCase.execute();
    };

    public vtoEnabled = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.CTA,
            vtoType: payload.vtoType
        };
        const vtoEnabledUseCase = new VTOActionUseCase(vtoAction);

        vtoEnabledUseCase.execute();
    };

    public vtoEngineClosed = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.ENGINE_CLOSED,
            vtoType: payload.vtoType
        };
        const vtoEngineClosedUseCase = new VTOActionUseCase(vtoAction);

        vtoEngineClosedUseCase.execute();
    };

    public vtoFoundationQrCodeOverlayClosed = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.FOUNDATION_QR_CODE_OVERLAY_CLOSED,
            vtoType: payload.vtoType
        };
        const vtoFoundationQrCodeOverlayClosedUseCase = new VTOActionUseCase(vtoAction);

        vtoFoundationQrCodeOverlayClosedUseCase.execute();
    };

    public vtoFoundationQrCodeOverlayOpened = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.FOUNDATION_QR_CODE_OVERLAY_OPENED,
            vtoType: payload.vtoType
        };
        const vtoFoundationQrCodeOverlayOpenedUseCase = new VTOActionUseCase(vtoAction);

        vtoFoundationQrCodeOverlayOpenedUseCase.execute();
    };

    public vtoLoaded = (payload: IVtoLoaded) => {
        const vtoAction = {
            event: VTO_EVENTS.LOADED,
            vtoType: payload.vtoType,
            eventValue: payload.eventValue
        };
        const vtoLoadedUseCase = new VTOActionUseCase(vtoAction);

        vtoLoadedUseCase.execute();
    };

    public vtoLoading = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.LOADING,
            vtoType: payload.vtoType
        };
        const vtoLoadingUseCase = new VTOActionUseCase(vtoAction);

        vtoLoadingUseCase.execute();
    };

    public vtoKissDetected = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.KISS_DETECTED,
            vtoType: payload.vtoType
        };
        const vtoKissDetectedUseCase = new VTOActionUseCase(vtoAction);

        vtoKissDetectedUseCase.execute();
    };

    public vtoOpened = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.OPENED,
            vtoType: payload.vtoType
        };
        const vtoOpenedUseCase = new VTOActionUseCase(vtoAction);

        vtoOpenedUseCase.execute();
    };

    public vtoPairShadeGridOpened = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.PAIR_SHADE_GRID_OPENED,
            vtoType: payload.vtoType
        };
        const vtoOpenedUseCase = new VTOActionUseCase(vtoAction);

        vtoOpenedUseCase.execute();
    };

    public vtoPairShadeSelected = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.PAIR_SHADE_SELECTED,
            vtoType: payload.vtoType
        };
        const vtoOpenedUseCase = new VTOActionUseCase(vtoAction);

        vtoOpenedUseCase.execute();
    };

    public vtoPhotoLoaded = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.PHOTO_LOADED,
            vtoType: payload.vtoType
        };
        const vtoPhotoLoadedUseCase = new VTOActionUseCase(vtoAction);

        vtoPhotoLoadedUseCase.execute();
    };

    public vtoPhotoSaved = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.PHOTO_SAVED,
            vtoType: payload.vtoType
        };
        const vtoPhotoSavedUseCase = new VTOActionUseCase(vtoAction);

        vtoPhotoSavedUseCase.execute();
    };

    public vtoPriceSuppressed = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.PRICE_SUPPRESSED,
            vtoType: payload.vtoType
        };
        const vtoPriceSuppressedUsedCase = new VTOActionUseCase(vtoAction);

        vtoPriceSuppressedUsedCase.execute();
    };

    public vtoReset = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.RESET,
            vtoType: payload.vtoType
        };
        const vtoResetUseCase = new VTOActionUseCase(vtoAction);

        vtoResetUseCase.execute();
    };

    public vtoVideoLoaded = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.VIDEO_LOADED,
            vtoType: payload.vtoType
        };
        const vtoVideoLoadedUseCase = new VTOActionUseCase(vtoAction);

        vtoVideoLoadedUseCase.execute();
    };

    public vtoViewAllShades = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.ALL_SHADES_VIEWED,
            vtoType: payload.vtoType
        };
        const vtoViewAllShadesUseCase = new VTOActionUseCase(vtoAction);

        vtoViewAllShadesUseCase.execute();
    };

    public vtoViewBestShades = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.BEST_SHADES_VIEWED,
            vtoType: payload.vtoType
        };
        const vtoViewBestShadesUseCase = new VTOActionUseCase(vtoAction);

        vtoViewBestShadesUseCase.execute();
    };

    public vtoShadeFinderStarted = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SHADE_FINDER_STARTED,
            vtoType: payload.vtoType
        };
        const vtoShadeFinderStartedUseCase = new VTOActionUseCase(vtoAction);

        vtoShadeFinderStartedUseCase.execute();
    };

    public vtoShadeFinderCompleted = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SHADE_FINDER_COMPLETED,
            vtoType: payload.vtoType
        };
        const vtoShadeFinderCompletedUseCase = new VTOActionUseCase(vtoAction);

        vtoShadeFinderCompletedUseCase.execute();
    };

    public vtoShadeFinderCancelled = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SHADE_FINDER_CANCELLED,
            vtoType: payload.vtoType
        };
        const vtoShadeFinderCancelledUseCase = new VTOActionUseCase(vtoAction);

        vtoShadeFinderCancelledUseCase.execute();
    };

    public vtoSkinShadeFound = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SKIN_SHADE_FOUND,
            vtoType: payload.vtoType
        };
        const vtoSkinShadeFoundUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinShadeFoundUseCase.execute();
    };

    public vtoSplitFourWay = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SPLIT_FOUR_WAY,
            vtoType: payload.vtoType
        };
        const vtoSplitFourWayUseCase = new VTOActionUseCase(vtoAction);

        vtoSplitFourWayUseCase.execute();
    };

    public vtoSplitFourWayDisabled = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SPLIT_FOUR_WAY_DISABLED,
            vtoType: payload.vtoType
        };
        const vtoSplitFourWayDisabledUseCase = new VTOActionUseCase(vtoAction);

        vtoSplitFourWayDisabledUseCase.execute();
    };

    public vtoShadeReminderOverlayOpened = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SHADE_REMINDER_OVERLAY_OPENED,
            vtoType: payload.vtoType
        };
        const vtoShadeReminderOverlayOpenedUseCase = new VTOActionUseCase(vtoAction);

        vtoShadeReminderOverlayOpenedUseCase.execute();
    };

    public vtoShadeReminderOverlayClosed = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SHADE_REMINDER_OVERLAY_CLOSED,
            vtoType: payload.vtoType
        };
        const vtoShadeReminderOverlayClosedUseCase = new VTOActionUseCase(vtoAction);

        vtoShadeReminderOverlayClosedUseCase.execute();
    };

    public vtoShadeReminderOverlayRetained = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SHADE_REMINDER_OVERLAY_KEEP,
            vtoType: payload.vtoType
        };
        const vtoShadeReminderOverlayRetainedUseCase = new VTOActionUseCase(vtoAction);

        vtoShadeReminderOverlayRetainedUseCase.execute();
    };

    public vtoShadeReminderRetaken = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SHADE_REMINDER_OVERLAY_RETAKE,
            vtoType: payload.vtoType
        };
        const vtoShadeReminderRetakenUseCase = new VTOActionUseCase(vtoAction);

        vtoShadeReminderRetakenUseCase.execute();
    };

    public vtoZoom = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.ZOOM,
            vtoType: payload.vtoType
        };
        const vtoZoomUseCase = new VTOActionUseCase(vtoAction);

        vtoZoomUseCase.execute();
    };

    public vtoMatchSaved = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.MATCH_SAVED,
            vtoType: payload.vtoType
        };
        const vtoMatchSavedUseCase = new VTOActionUseCase(vtoAction);

        vtoMatchSavedUseCase.execute();
    };

    public vtoMatchRemoved = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.MATCH_REMOVED,
            vtoType: payload.vtoType
        };
        const vtoMatchRemovedUseCase = new VTOActionUseCase(vtoAction);

        vtoMatchRemovedUseCase.execute();
    };

    public vtoMatchPersonalized = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.MATCH_PERSONALIZED,
            vtoType: payload.vtoType
        };
        const vtoMatchPersonalizedUseCase = new VTOActionUseCase(vtoAction);

        vtoMatchPersonalizedUseCase.execute();
    };

    public vtoSkinCareOpened = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.OPENED,
            vtoType: payload.vtoType
        };
        const vtoSkinCareOpenedUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinCareOpenedUseCase.execute();
    };

    public vtoSkinCareCameraOpened = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.CAMERA_OPENED,
            vtoType: payload.vtoType
        };
        const vtoSkinCareCameraOpenedUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinCareCameraOpenedUseCase.execute();
    };

    public vtoSkinCareCameraFailed = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.CAMERA_FAILED,
            vtoType: payload.vtoType
        };
        const vtoSkinCareCameraFailedUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinCareCameraFailedUseCase.execute();
    };

    public vtoSkinCareCameraClosed = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.CAMERA_CLOSED,
            vtoType: payload.vtoType
        };
        const vtoSkinCareCameraClosedUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinCareCameraClosedUseCase.execute();
    };

    public vtoSkinCareLoading = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.LOADING,
            vtoType: payload.vtoType
        };
        const vtoSkinCareLoadingUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinCareLoadingUseCase.execute();
    };

    public vtoSkinCareLoaded = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.LOADED,
            vtoType: payload.vtoType
        };
        const vtoSkinCareLoadedUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinCareLoadedUseCase.execute();
    };

    public vtoSkinCareVideoLoaded = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.VIDEO_LOADED,
            vtoType: payload.vtoType
        };
        const vtoSkinCareVideoLoadedUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinCareVideoLoadedUseCase.execute();
    };

    public vtoSkinCareAnalysisStarted = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SKIN_ANALYSIS_STARTED,
            vtoType: payload.vtoType
        };
        const vtoSkinCareAnalysisStartedUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinCareAnalysisStartedUseCase.execute();
    };

    public vtoSkinCareAnalysisFinished = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SKIN_ANALYSIS_FINISHED,
            vtoType: payload.vtoType
        };
        const vtoSkinCareAnalysisFinishedUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinCareAnalysisFinishedUseCase.execute();
    };

    public vtoSkinCareBackToDetecting = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SKIN_BACK_TO_DETECTING,
            vtoType: payload.vtoType
        };
        const vtoSkinCareBackToDetectingUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinCareBackToDetectingUseCase.execute();
    };

    public vtoSkinCareClosed = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.CLOSED,
            vtoType: payload.vtoType
        };
        const vtoSkinCareClosedUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinCareClosedUseCase.execute();
    };

    public vtoSkinCareProductsLoaded = (payload: ISkinCareProducts) => {
        const { SHOPPABLE_PRODUCTS_LOADED, NON_SHOPPABLE_PRODUCTS_LOADED } = VTO_EVENTS;
        const event = payload.isShoppable
            ? SHOPPABLE_PRODUCTS_LOADED
            : NON_SHOPPABLE_PRODUCTS_LOADED;
        const vtoAction = {
            event,
            vtoType: payload.vtoType
        };
        const vtoSkinCareProductsLoadedUseCase = new VTOActionUseCase(vtoAction);

        vtoSkinCareProductsLoadedUseCase.execute();
    };

    public vtoSurveyIgnored = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SURVEY_IGNORED,
            vtoType: payload.vtoType
        };
        const vtoSurveyIgnoredUseCase = new VTOActionUseCase(vtoAction);

        vtoSurveyIgnoredUseCase.execute();
    };
    public vtoSurveyLoaded = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SURVEY_LOADED,
            vtoType: payload.vtoType
        };
        const vtoSurveyLoadedUseCase = new VTOActionUseCase(vtoAction);

        vtoSurveyLoadedUseCase.execute();
    };
    public vtoSurveySubmitted = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.SURVEY_SUBMITTED,
            vtoType: payload.vtoType
        };
        const vtoSurveySubmittedUseCase = new VTOActionUseCase(vtoAction);

        vtoSurveySubmittedUseCase.execute();
    };

    public vtoTutorialStarted = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.TUTORIAL_STARTED,
            vtoType: payload.vtoType
        };
        const vtoTutorialStartedUseCase = new VTOActionUseCase(vtoAction);

        vtoTutorialStartedUseCase.execute();
    };

    public vtoTutorialUnmuted = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.TUTORIAL_UNMUTED,
            vtoType: payload.vtoType
        };
        const vtoTutorialUnmutedUseCase = new VTOActionUseCase(vtoAction);

        vtoTutorialUnmutedUseCase.execute();
    };

    public vtoTutorialMuted = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.TUTORIAL_MUTED,
            vtoType: payload.vtoType
        };
        const vtoTutorialMutedUseCase = new VTOActionUseCase(vtoAction);

        vtoTutorialMutedUseCase.execute();
    };

    public vtoTutorialPaused = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.TUTORIAL_PAUSED,
            vtoType: payload.vtoType
        };
        const vtoTutorialPausedUseCase = new VTOActionUseCase(vtoAction);

        vtoTutorialPausedUseCase.execute();
    };

    public vtoTutorialStopped = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.TUTORIAL_STOPPED,
            vtoType: payload.vtoType
        };
        const vtoTutorialStoppedUseCase = new VTOActionUseCase(vtoAction);

        vtoTutorialStoppedUseCase.execute();
    };

    public vtoTutorialResumed = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.TUTORIAL_RESUMED,
            vtoType: payload.vtoType
        };
        const vtoTutorialResumedUseCase = new VTOActionUseCase(vtoAction);

        vtoTutorialResumedUseCase.execute();
    };

    public vtoTutorialPlaySpeedUpdated = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.TUTORIAL_PLAY_SPEED_UPDATED,
            vtoType: payload.vtoType
        };
        const vtoTutorialPlaySpeedUpdatedUseCase = new VTOActionUseCase(vtoAction);

        vtoTutorialPlaySpeedUpdatedUseCase.execute();
    };

    public vtoTutorialPreviousStep = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.TUTORIAL_PREVIOUS_STEP,
            vtoType: payload.vtoType
        };
        const vtoTutorialPreviousStepUseCase = new VTOActionUseCase(vtoAction);

        vtoTutorialPreviousStepUseCase.execute();
    };

    public vtoTutorialNextStep = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.TUTORIAL_NEXT_STEP,
            vtoType: payload.vtoType
        };
        const vtoTutorialNextStepUseCase = new VTOActionUseCase(vtoAction);

        vtoTutorialNextStepUseCase.execute();
    };

    public vtoLookSelected = (payload: IVtoLookSelected) => {
        const vtoAction = {
            event: VTO_EVENTS.TUTORIAL_LOOK_SELECTED,
            vtoType: payload.vtoType,
            vtoLookIndex: payload.vtoLookIndex,
            vtoLookId: payload.vtoLookId
        };
        const vtoLookSelectedUseCase = new VTOActionUseCase(vtoAction);
        vtoLookSelectedUseCase.execute();
    };

    public vtoProductListClicked = (payload: IVtoType) => {
        const vtoAction = {
            event: VTO_EVENTS.TUTORIAL_PRODUCT_LIST_CLICKED,
            vtoType: payload.vtoType
        };
        const vtoProductListClickedUseCase = new VTOActionUseCase(vtoAction);
        vtoProductListClickedUseCase.execute();
    };

    public vtoProductsUsedItemClicked = (payload: IVtoProductsUsedItemClicked) => {
        const vtoAction = {
            event: VTO_EVENTS.TUTORIAL_PRODUCTS_USED_ITEM_CLICKED,
            vtoType: payload.vtoType,
            vtoItemId: payload.vtoItemId
        };
        const vtoProductsUsedItemClickedUseCase = new VTOActionUseCase(vtoAction);
        vtoProductsUsedItemClickedUseCase.execute();
    };

    public vtoFaceAttributePredictionStarted = (payload: IVtoType) => {
        const vtoFaceAttributePredictionStartedUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_FACE_ATTRIBUTE_PREDICTION_STARTED,
            ...payload
        });
        vtoFaceAttributePredictionStartedUseCase.execute();
    };

    public vtoFaceAttributeUpdated = (payload: IVtoType) => {
        const vtoFaceAttributeUpdatedUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_FACE_ATTRIBUTE_UPDATED,
            ...payload
        });
        vtoFaceAttributeUpdatedUseCase.execute();
    };

    public vtoBrowGoalSelected = (payload: IVtoBrowGoalSelected) => {
        const vtoBrowGoalSelectedUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_GOAL_SELECTED,
            ...payload
        });
        vtoBrowGoalSelectedUseCase.execute();
    };

    public vtoTipsClicked = (payload: IVtoType) => {
        const vtoTipsClickedUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_TIPS_CLICKED,
            ...payload
        });
        vtoTipsClickedUseCase.execute();
    };

    public vtoBackToGoalsClicked = (payload: IVtoType) => {
        const vtoBackToGoalsClickedUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_BACK_TO_GOALS_CLICKED,
            ...payload
        });
        vtoBackToGoalsClickedUseCase.execute();
    };

    public vtoShapeChanged = (payload: IVtoShapeChanged) => {
        const vtoShapeChangedUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_SHAPE_CHANGED,
            ...payload
        });
        vtoShapeChangedUseCase.execute();
    };

    public vtoBrowShadeTryOn = (payload: IVtoBrowShadeTryOn) => {
        const vtoBrowShadeTryOnUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_SHADE_TRY_ON,
            ...payload
        });
        vtoBrowShadeTryOnUseCase.execute();
    };

    public vtoLengthChanged = (payload: IVtoLengthChanged) => {
        const vtoLengthChangedUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_LENGTH_CHANGED,
            ...payload
        });
        vtoLengthChangedUseCase.execute();
    };

    public vtoThicknessChanged = (payload: IVtoThicknessChanged) => {
        const vtoThicknessChangedUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_THICKNESS_CHANGED,
            ...payload
        });
        vtoThicknessChangedUseCase.execute();
    };

    public vtoOpacityChanged = (payload: IVtoOpacityChanged) => {
        const vtoOpacityChangedUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_OPACITY_CHANGED,
            ...payload
        });
        vtoOpacityChangedUseCase.execute();
    };

    public vtoGoldenRatioEnabled = (payload: IVtoType) => {
        const vtoGoldenRatioEnabledUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_GOLDEN_RATION_ENABLED,
            ...payload
        });
        vtoGoldenRatioEnabledUseCase.execute();
    };

    public vtoGoldenRatioDisabled = (payload: IVtoType) => {
        const vtoGoldenRatioDisabledUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_GOLDEN_RATION_DISABLED,
            ...payload
        });
        vtoGoldenRatioDisabledUseCase.execute();
    };

    public vtoStencilEnabled = (payload: IVtoType) => {
        const vtoStencilEnabledUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_STENCIL_ENABLED,
            ...payload
        });
        vtoStencilEnabledUseCase.execute();
    };

    public vtoStencilDisabled = (payload: IVtoType) => {
        const vtoStencilDisabledUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_STENCIL_DISABLED,
            ...payload
        });
        vtoStencilDisabledUseCase.execute();
    };

    public vtoCompareEnabled = (payload: IVtoType) => {
        const vtoCompareEnabledUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_COMPARE_ENABLED,
            ...payload
        });
        vtoCompareEnabledUseCase.execute();
    };

    public vtoCaptureClicked = (payload: IVtoType) => {
        const vtoCaptureClickedUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_CAPTURE_CLICKED,
            ...payload
        });
        vtoCaptureClickedUseCase.execute();
    };

    public vtoSeeAllShadesClicked = (payload: IVtoType) => {
        const vtoSeeAllShadesClickedUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_SEE_ALL_SHADES_CLICKED,
            ...payload
        });
        vtoSeeAllShadesClickedUseCase.execute();
    };

    public vtoGetBrowClicked = (payload: IVtoType) => {
        const vtoGetBrowClickedUseCase = new VTOActionUseCase({
            event: VTO_EVENTS.BROW_GET_BROW_CLICKED,
            ...payload
        });
        vtoGetBrowClickedUseCase.execute();
    };

    public engravingTriggered = (payload: {
        skuId: string;
        skuBaseId?: number;
        size: string;
        price: string;
        name: string;
    }) => {
        const skuEngravingUseCase = new SkuEngravingUseCase(payload);
        skuEngravingUseCase.execute();
    };

    public writeReviewEventTriggered = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(events.WRITE_REVIEWS_LINK_CLICKED, {
            ...payload,
            eventAction: ReviewsEventAction.WRITE_REVIEW
        });
        ratingsReviewsUseCase.execute();
    };

    public readReviewsEventTriggered = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(events.WRITE_REVIEWS_LINK_CLICKED, {
            ...payload,
            eventAction: ReviewsEventAction.READ_REVIEW
        });
        ratingsReviewsUseCase.execute();
    };

    public reviewsHelpfulYesClicked = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(
            events.REVIEWS_HELPFUL_YES_CLICKED,
            {
                ...payload,
                eventAction: ReviewsEventAction.HELPFUL_YES
            }
        );
        ratingsReviewsUseCase.execute();
    };

    public reviewsHelpfulNoClicked = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(events.REVIEWS_HELPFUL_NO_CLICKED, {
            ...payload,
            eventAction: ReviewsEventAction.HELPFUL_NO
        });
        ratingsReviewsUseCase.execute();
    };

    public reviewsFlagReviewClicked = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(
            events.REVIEWS_FLAG_REVIEW_CLICKED,
            {
                ...payload,
                eventAction: ReviewsEventAction.FLAG_REVIEW
            }
        );
        ratingsReviewsUseCase.execute();
    };

    public reviewsFilterClicked = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(events.REVIEWS_FILTER_CLICKED, {
            ...payload,
            eventAction: ReviewsEventAction.REVIEWS_FILTER
        });
        ratingsReviewsUseCase.execute();
    };

    public reviewsSearchClicked = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(events.REVIEWS_SEARCH_CLICKED, {
            ...payload,
            eventAction: ReviewsEventAction.REVIEWS_SEARCH
        });
        ratingsReviewsUseCase.execute();
    };

    public askAndAnswerClicked = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(events.ASK_AND_ANSWER_CLICKED, {
            ...payload,
            eventAction: ReviewsEventAction.ASK_AND_ANSWER
        });
        ratingsReviewsUseCase.execute();
    };

    public askAndAnswerSubmitted = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(events.ASK_AND_ANSWER_SUBMITTED, {
            ...payload,
            eventAction: ReviewsEventAction.ASK_AND_ANSWER_SUBMIT
        });
        ratingsReviewsUseCase.execute();
    };

    public askAndAnswerSearchClicked = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(
            events.ASK_AND_ANSWER_SEARCH_CLICKED,
            {
                ...payload,
                eventAction: ReviewsEventAction.ASK_AND_ANSWER_SEARCH
            }
        );
        ratingsReviewsUseCase.execute();
    };

    public askAndAnswerHelpfulYesClicked = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(
            events.ASK_AND_ANSWER_HELPFUL_YES_CLICKED,
            {
                ...payload,
                eventAction: ReviewsEventAction.ASK_AND_ANSWER_HELPFUL_YES
            }
        );
        ratingsReviewsUseCase.execute();
    };

    public askAndAnswerHelpfulNoClicked = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(
            events.ASK_AND_ANSWER_HELPFUL_NO_CLICKED,
            {
                ...payload,
                eventAction: ReviewsEventAction.ASK_AND_ANSWER_HELPFUL_NO
            }
        );
        ratingsReviewsUseCase.execute();
    };

    public askAndAnswerShowMoreClicked = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(
            events.ASK_AND_ANSWER_SHOW_MORE_CLICKED,
            {
                ...payload,
                eventAction: ReviewsEventAction.ASK_AND_ANSWER_SHOW_MORE
            }
        );
        ratingsReviewsUseCase.execute();
    };

    public reviewsSortByChanged = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(events.REVIEWS_SORT_BY_CHANGED, {
            ...payload,
            eventAction: ReviewsEventAction.REVIEW_SORT
        });
        ratingsReviewsUseCase.execute();
    };

    public askAndAnswerSortByChanged = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(
            events.ASK_AND_ANSWERS_SORT_BY_CHANGED,
            {
                ...payload,
                eventAction: ReviewsEventAction.ASK_AND_ANSWER_SORT
            }
        );
        ratingsReviewsUseCase.execute();
    };

    public writeReviewStarted = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(events.WRITE_REVIEW_STARTED, {
            ...payload,
            eventAction: ReviewsEventAction.WRITE_REVIEW
        });
        ratingsReviewsUseCase.execute();
    };

    public reviewOverlayOpened = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(events.REVIEW_OVERLAY_OPENED, {
            ...payload,
            eventAction: ReviewsEventAction.REVIEW_OVERLAY_OPEN
        });
        ratingsReviewsUseCase.execute();
    };

    public reviewOverlayClosed = (payload: IReviewsParam) => {
        const ratingsReviewsUseCase = new RatingsReviewsUseCase(events.REVIEW_OVERLAY_CLOSED, {
            ...payload,
            eventAction: ReviewsEventAction.REVIEW_OVERLAY_CLOSE
        });
        ratingsReviewsUseCase.execute();
    };

    public smartGiftAdded = (payload: ISmartGiftParam) => {
        const smartGiftUseCase = new SmartGiftUseCase(events.SMARTGIFT_ADDED, {
            ...payload,
            eventAction: SmartGiftEventAction.SMARTGIFT_ADDED
        });
        smartGiftUseCase.execute();
    };

    public smartGiftViewed = (payload: ISmartGiftParam) => {
        const smartGiftUseCase = new SmartGiftUseCase(events.SMARTGIFT_VIEWED, {
            ...payload,
            eventAction: SmartGiftEventAction.SMARTGIFT_VIEWED
        });
        smartGiftUseCase.execute();
    };

    public smartGiftPrepared = (payload: ISmartGiftParam) => {
        const smartGiftUseCase = new SmartGiftUseCase(events.SMARTGIFT_PREPARED, {
            ...payload,
            eventAction: SmartGiftEventAction.SMARTGIFT_PREPARED
        });
        smartGiftUseCase.execute();
    };

    public smartGiftWidgetToggled = (payload: ISmartGiftParam) => {
        const smartGiftUseCase = new SmartGiftUseCase(events.SMARTGIFT_WIDGET_TOGGLED, {
            ...payload,
            eventAction: SmartGiftEventAction.SMARTGIFT_WIDGET_TOGGLED
        });
        smartGiftUseCase.execute();
    };

    public smartGiftRemoved = (payload: ISmartGiftParam) => {
        const smartGiftUseCase = new SmartGiftUseCase(events.SMARTGIFT_REMOVED, {
            ...payload,
            eventAction: SmartGiftEventAction.SMARTGIFT_REMOVED
        });
        smartGiftUseCase.execute();
    };

    public smartGiftCancelled = (payload: ISmartGiftParam) => {
        const smartGiftUseCase = new SmartGiftUseCase(events.SMARTGIFT_CANCELLED, {
            ...payload,
            eventAction: SmartGiftEventAction.SMARTGIFT_CANCELLED
        });
        smartGiftUseCase.execute();
    };

    public smartgiftHelpOpen = (payload: ISmartGiftParam) => {
        const smartGiftUseCase = new SmartGiftUseCase(events.SMARTGIFT_HELP_OPENED, {
            ...payload,
            eventAction: SmartGiftEventAction.SMARTGIFT_HELP_OPENED
        });
        smartGiftUseCase.execute();
    };

    public smartgiftHelpClosed = (payload: ISmartGiftParam) => {
        const smartGiftUseCase = new SmartGiftUseCase(events.SMARTGIFT_HELP_CLOSED, {
            ...payload,
            eventAction: SmartGiftEventAction.SMARTGIFT_HELP_CLOSED
        });
        smartGiftUseCase.execute();
    };

    public accountSidebarOverlayOpened = async () => {
        const accountSidebarOverlayOpenedUseCase = new AccountSidebarOverlayOpenedUseCase();
        accountSidebarOverlayOpenedUseCase.execute();
    };

    public accountSidebarMenuClicked = (payload: IAccountSidebarBaseData) => {
        const accountSidebarUseCase = new AccountSidebarMenuOptionClickedUseCase({
            ...payload,
            eventAction: AccountEventAction.ACCOUNT_SIDEBAR_MENU_CLICKED
        });
        accountSidebarUseCase.execute();
    };

    public accountSidebarLoyaltyClicked = (payload: IAccountSidebarBaseData) => {
        const accountSidebarUseCase = new AccountSidebarMenuOptionClickedUseCase({
            ...payload,
            eventAction: AccountEventAction.ACCOUNT_SIDEBAR_LOYALTY_CLICKED
        });
        accountSidebarUseCase.execute();
    };

    public accountSidebarShowcaseClicked = (payload: IAccountSidebarShowcaseData) => {
        const accountSidebarUseCase = new AccountSidebarShowcaseClickedUseCase({
            ...payload,
            eventAction: AccountEventAction.ACCOUNT_SIDEBAR_SHOWCASE_CLICKED
        });
        accountSidebarUseCase.execute();
    };

    public accountLoyaltyPointsInfoLinkClicked = (payload: IAccountSidebarBaseData) => {
        const accountLoyaltyPointsInfoCLickedUseCase = new AccountLoyaltyPointsInfoUseCase({
            ...payload,
            eventAction: AccountEventAction.ACCOUNT_LOYALTY_POINTS_INFO_LINK_CLICKED
        });
        accountLoyaltyPointsInfoCLickedUseCase.execute();
    };

    public accountNonLoyaltyEnrollmentSignupClicked = (payload: IAccountSidebarBaseData) => {
        const accountNonLoyaltyEnrollmentSignupUseCase = new AccountNonLoyaltyEnrollmentSignupUseCase(
            {
                ...payload,
                eventAction: AccountEventAction.ACCOUNT_NONLOYALTY_ENROLLMENT_SIGNUP_CLICKED
            }
        );
        accountNonLoyaltyEnrollmentSignupUseCase.execute();
    };

    public accountNonLoyaltyEnrollmentLinkClicked = (payload: IAccountSidebarBaseData) => {
        const accountNonLoyaltyEnrollmentLinkClickedUseCase = new AccountNonLoyaltyEnrollmentLinkUseCase(
            {
                ...payload,
                eventAction: AccountEventAction.ACCOUNT_NONLOYALTY_ENROLLMENT_LINK_CLICKED
            }
        );
        accountNonLoyaltyEnrollmentLinkClickedUseCase.execute();
    };

    public liveChatInterfaceClicked = (payload: IGenericAnalyticsData) => {
        const liveChatInterfaceClicked = new LiveChatInterfaceClickedUseCase(payload);
        liveChatInterfaceClicked.execute();
    };

    public socialShareIconTriggered = (payload: IGenericAnalyticsData) => {
        const socialShareIconTriggered = new SocialShareIconTriggeredUseCase(payload);
        socialShareIconTriggered.execute();
    };

    public skuPickerOpened = (payload: { productId: string }) => {
        const { productId } = payload;
        const skuPickerOpened = new SkuPickerInteractionUseCase(productId, ActionType.OPEN);
        skuPickerOpened.execute();
    };

    public skuPickerClosed = (payload: { productId: string }) => {
        const { productId } = payload;
        const skuPickerClosed = new SkuPickerInteractionUseCase(productId, ActionType.CLOSE);
        skuPickerClosed.execute();
    };

    public appointmentVirtualSelected = () => {
        const appointmentVirtualSelected = new AppointmentVirtualSelectedUseCase();
        void appointmentVirtualSelected.execute();
    };

    public appointmentLocationSelected = (payload: { storeName: string }) => {
        const { storeName } = payload;
        const appointmentLocationSelected = new AppointmentLocationSelectedUseCase(storeName);
        void appointmentLocationSelected.execute();
    };

    public appointmentServiceSelected = (payload: { serviceName: string[] }) => {
        const { serviceName } = payload;
        const appointmentServiceSelected = new AppointmentServiceSelectedUseCase(serviceName);
        void appointmentServiceSelected.execute();
    };

    public appointmentDateTimeSelected = (payload: { dateTime: string }) => {
        const { dateTime } = payload;
        const appointmentDateTimeSelected = new AppointmentDateTimeSelectedUseCase(dateTime);
        void appointmentDateTimeSelected.execute();
    };

    public appointmentEditClicked = () => {
        const appointmentEditClicked = new AppointmentEditClickedUseCase();
        void appointmentEditClicked.execute();
    };

    public appointmentStartedOver = () => {
        const appointmentStartedOver = new AppointmentStartedOverUseCase();
        void appointmentStartedOver.execute();
    };

    public appointmentArtistSelected = (payload: { artistName: string }) => {
        const { artistName } = payload;
        const appointmentArtistSelected = new AppointmentArtistSelectedUseCase(artistName);
        void appointmentArtistSelected.execute();
    };

    public appointmentStepLoaded = (payload: { step: string }) => {
        const { step } = payload;
        const appointmentStepLoaded = new AppointmentStepLoadedUseCase(step);
        void appointmentStepLoaded.execute();
    };

    public appointmentProcessCompleted = () => {
        const appointmentProcessCompleted = new AppointmentProcessCompletedUseCase();
        void appointmentProcessCompleted.execute();
    };

    public appointmentAddedToCalendar = () => {
        const appointmentAddedToCalendar = new AppointmentAddedToCalendarUseCase();
        void appointmentAddedToCalendar.execute();
    };

    public loyaltyLoadMoreLinkClicked = () => {
        const payload = LoyaltyEventAction.LOYALTY_LOADMORE_TEXT;
        const eventLoadAction = events.LOYALTY_LOADMORE_LINK_CLICKED;
        const loyaltyLoadMoreLinkUseCase = new LoyaltyPointsUseCase(payload, eventLoadAction);
        loyaltyLoadMoreLinkUseCase.execute();
    };

    public loyaltyOnlineOrderNumberClicked = (payload: string) => {
        const payloadData = payload?.replace('#', '').trim();
        const eventOnlineAction = events.LOYALTY_ONLINE_ORDER_NUMBER_CLICKED;
        const loyaltyActivityLinkUseCase = new LoyaltyPointsUseCase(payloadData, eventOnlineAction);
        loyaltyActivityLinkUseCase.execute();
    };

    public loyaltyShopNowClicked = (payload: string) => {
        const eventShopAction = events.LOYALTY_SHOP_NOW_CLICKED;
        const loyaltyActivityLinkUseCase = new LoyaltyBenefitsUseCase(payload, eventShopAction);
        loyaltyActivityLinkUseCase.execute();
    };

    public loyaltyAllBenefitsClicked = (payload: string) => {
        const eventAllBenefitsAction = events.LOYALTY_ALL_BENEFITS_CLICKED;
        const loyaltyAllBenefitsUseCase = new LoyaltyBenefitsUseCase(
            payload,
            eventAllBenefitsAction
        );
        loyaltyAllBenefitsUseCase.execute();
    };

    public loyaltyBenefitsRedeemClicked = (payload: string) => {
        const eventRedeemAction = events.LOYALTY_BENEFITS_REDEEM_CLICKED;
        const payloadData = `${LoyaltyEventAction.LOYALTY_OFFER_SELECTED} -  ${payload}`;
        const loyaltyBenefitsRedeemUseCase = new LoyaltyBenefitsUseCase(
            payloadData,
            eventRedeemAction
        );
        loyaltyBenefitsRedeemUseCase.execute();
    };

    public loyaltyBenefitsRemoveClicked = (payload: string) => {
        const eventRemoveAction = events.LOYALTY_BENEFITS_REMOVE_CLICKED;
        const payloadData = `${LoyaltyEventAction.LOYALTY_OFFER_REMOVED} -  ${payload}`;
        const loyaltyBenefitsRemoveUseCase = new LoyaltyBenefitsUseCase(
            payloadData,
            eventRemoveAction
        );
        loyaltyBenefitsRemoveUseCase.execute();
    };

    public loyaltyRewardsRedeemClicked = () => {
        const eventRedeemAction = events.LOYALTY_REWARDS_REDEEM_CLICKED;
        const payload = LoyaltyEventAction.LOYALTY_REWARD_SELECTED;
        const loyaltyRewardsRedeemUseCase = new LoyaltyRewardsUseCase(payload, eventRedeemAction);
        loyaltyRewardsRedeemUseCase.execute();
    };

    public loyaltyRewardsRemoveClicked = () => {
        const eventRemoveAction = events.LOYALTY_REWARDS_REMOVE_CLICKED;
        const payload = LoyaltyEventAction.LOYALTY_REWARD_REMOVED;
        const loyaltyRewardsRemoveUseCase = new LoyaltyRewardsUseCase(payload, eventRemoveAction);
        loyaltyRewardsRemoveUseCase.execute();
    };

    public loyaltyRewardsTabClicked = (payload: string) => {
        const eventTabAction = events.LOYALTY_REWARDS_TAB_CLICKED;
        const loyaltyRewardsTabUseCase = new LoyaltyRewardsUseCase(payload, eventTabAction);
        loyaltyRewardsTabUseCase.execute();
    };

    public appointmentReviewWidgetClick = (payload: { serviceName: string }) => {
        const { serviceName } = payload;
        const appointmentReviewWidgetClick = new AppointmentReviewWidgetClickUseCase(serviceName);
        appointmentReviewWidgetClick.execute();
    };

    public appointmentReviewPagination = (payload: { optionSelection: string }) => {
        const { optionSelection } = payload;
        const appointmentReviewPagination = new AppointmentReviewPaginationUseCase(optionSelection);
        appointmentReviewPagination.execute();
    };

    public appointmentReviewWidgetFilters = (payload: {
        location: string;
        sortBy: string;
        serviceName: string;
    }) => {
        const { location, sortBy, serviceName } = payload;
        const appointmentReviewWidgetFilters = new AppointmentReviewWidgetFiltersUseCase({
            location,
            sortBy,
            serviceName
        });
        appointmentReviewWidgetFilters.execute();
    };

    public appointmentAccountButtonClicked = (payload: { accountButtonLabel: string }) => {
        const { accountButtonLabel } = payload;
        const appointmentAccountButtonClicked = new AppointmentAccountButtonClickedUseCase(
            accountButtonLabel
        );
        appointmentAccountButtonClicked.execute();
    };

    public storeDeliveryTypeSelected = (payload: IStoreDeliveryMethodsData) => {
        const storeDeliveryTypeSelectedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_DELIVERY_TYPE_SELECTED
        );
        storeDeliveryTypeSelectedUseCase.execute();
    };

    public storeSearchAddressSubmited = (payload: IStoreDeliveryMethodsData) => {
        const storeSearchAddressSubmitedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_SEARCH_ADDRESS_SUBMITTED
        );
        storeSearchAddressSubmitedUseCase.execute();
    };

    public storeChangeLinkClicked = (payload: IStoreDeliveryMethodsData) => {
        const storeChangeLinkClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_CHANGE_LINK_CLICKED
        );
        storeChangeLinkClickedUseCase.execute();
    };

    public storeSelected = (payload: IStoreDeliveryMethodsData) => {
        const storeSelectedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_SELECTED
        );
        storeSelectedUseCase.execute();
    };

    public storeOpeningHoursToggled = (payload: IStoreDeliveryMethodsData) => {
        const storeOpeningHoursToggledUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_OPENING_HOURS_TOGGLED
        );
        storeOpeningHoursToggledUseCase.execute();
    };

    public appointmentCallStoreClicked = (payload: { storeName: string }) => {
        const { storeName } = payload;
        const appointmentCallStoreClicked = new AppointmentCallStoreClickedUseCase(storeName);
        appointmentCallStoreClicked.execute();
    };

    public storeFilterToggled = (payload: IStoreDeliveryMethodsData) => {
        const storeFilterToggledUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_FILTER_TOGGLED
        );
        storeFilterToggledUseCase.execute();
    };

    public storeDirectoryLinkClicked =  (payload: IStoreDeliveryMethodsData) => {
        const storeDirectoryLinkClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_DIRECTORY_LINK_CLICKED
        );
        storeDirectoryLinkClickedUseCase.execute();
    };

    public storeDirectoryMapLinkClicked =  (payload: IStoreDeliveryMethodsData) => {
        const storeDirectoryMapLinkClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_DIRECTORY_MAP_LINK_CLICKED
        );
        storeDirectoryMapLinkClickedUseCase.execute();
    };

    public storeDirectoryStoreLinkClicked = (payload: IStoreDeliveryMethodsData) => {
        const storeDirectoryStoreLinkClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_DIRECTORY_STORE_LINK_CLICKED
        );
        storeDirectoryStoreLinkClickedUseCase.execute();
    };

    public storeMapMarkerClicked = (payload: IStoreDeliveryMethodsData) => {
        const storeMapMarkerClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_MAP_MARKER_CLICKED
        );
        storeMapMarkerClickedUseCase.execute();
    };

    public storeGetDirectionsLinkClicked = (payload: IStoreDeliveryMethodsData) => {
        const storeGetDirectionsLinkClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_GET_DIRECTIONS_CLICKED
        );
        storeGetDirectionsLinkClickedUseCase.execute();
    };

    public storeDetailsLinkClicked = (payload: IStoreDeliveryMethodsData) => {
        const storeDetailsLinkClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_DETAILS_LINK_CLICKED
        );
        storeDetailsLinkClickedUseCase.execute();
    };

    public storeBookAppointmentinkClicked = (payload: IStoreDeliveryMethodsData) => {
        const storeBookAppointmentinkClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_BOOK_APPOINTMENT_LINK_CLICKED
        );
        storeBookAppointmentinkClickedUseCase.execute();
    };

    public storeDetailsAddressLinkClicked = (payload: IStoreDeliveryMethodsData) => {
        const storeDetailsAddressLinkClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_DETAILS_ADDRESS_LINK_CLICKED
        );
        storeDetailsAddressLinkClickedUseCase.execute();
    };

    public storeDetailsInStorePickupLinkClicked = (payload: IStoreDeliveryMethodsData) => {
        const storeDetailsInStorePickupLinkClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_DETAILS_IN_STORE_PICKUP_LINK_CLICKED
        );
        storeDetailsInStorePickupLinkClickedUseCase.execute();
    };

    public storeNearByGetDirectionsLinkClicked = (payload: IStoreDeliveryMethodsData) => {
        const storeNearByGetDirectionsLinkClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_NEAR_BY_GET_DIRECTIONS_CLICKED
        );
        storeNearByGetDirectionsLinkClickedUseCase.execute();
    };

    public storeLocationResetLinkClicked = (payload: IStoreDeliveryMethodsData) => {
        const storeLocationResetLinkClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_LOCATION_RESET_CLICKED
        );
        storeLocationResetLinkClickedUseCase.execute();
    };

    public storeTabViewSectionClicked = (payload: IStoreDeliveryMethodsData) => {
        const storeTabViewSectionClickedUseCase = new StoreDeliveryMethodsUseCase(
            payload,
            events.STORE_TAB_VIEW_SECTION_CLICKED
        );
        storeTabViewSectionClickedUseCase.execute();
    };
}
